import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Environment} from '../../shared/environment/environment';
import {MaintenanceModeConfig} from '../../model/maintenance-config/maintenance-mode-config';
import {Observable, of} from 'rxjs';
import {flatMap, map, mergeMap} from 'rxjs/internal/operators';
import {CacheConstants} from '../../shared/cache-constants';
import {Cached} from '@ngx-cache/core';
import {MaintenancePropertyMapper} from './maintenance-property-mapper';
import {OcapiService} from '../ocapi/ocapi.service';
import {LocalApiService} from '../local-api/local-api.service';

@Injectable()
export class MaintenanceService {

  constructor(
    private httpClient: HttpClient,
    private localApiService: LocalApiService,
    private maintancePropertyMapper: MaintenancePropertyMapper,
    private ocapiService: OcapiService) {
  }

  @Cached(CacheConstants.PLANNED_MAINTENANCE)
  public getMaintenanceMode(): Observable<MaintenanceModeConfig> {
    return this.httpClient.get<MaintenanceModeConfig>(this.getMaintenanceModePropertyUrl()).pipe(
      flatMap((response: MaintenanceModeConfig) => {
        return this.isCpeIdInMaintenance(response).pipe(
          map(bool => {
            if (response.enabled) {
              response.enabled = bool;
            }
            return this.maintancePropertyMapper.mapProperty(response);
          })
        );
      })
    );
  }

  private getMaintenanceModePropertyUrl(): string {
    return Environment.environmentConfig().baseApiUrl + '/omapi/public/publicconfigs/planned_maintenance_eostvshop';
  }

  private isCpeIdInMaintenance(maintenanceModeConfig: any): Observable<boolean> {
    return this.ocapiService.getCpeIdBehaviorSubject().pipe(
        mergeMap(cpeIdParam => {
          if (cpeIdParam) {
            return of(this.containsCpeId(this.getCpeIdsThatIgnoreMaintenanceMode(maintenanceModeConfig), cpeIdParam));
          } else {
            return this.localApiService.getBoxCpeId().pipe(map((cpeid: string) => {
              return this.containsCpeId(this.getCpeIdsThatIgnoreMaintenanceMode(maintenanceModeConfig), cpeid);
            }));
          }
        }));
  }

  private containsCpeId(ignoredCpeIds: string[], cpeId: string): boolean {
    return ignoredCpeIds.filter(ignoredCpeId => ignoredCpeId === cpeId).length === 0;
  }

  private getCpeIdsThatIgnoreMaintenanceMode(maintenanceModeConfig: MaintenanceModeConfig): string[] {
    return maintenanceModeConfig.value ? JSON.parse(maintenanceModeConfig.value).cpeids_that_ignore_maintenance_mode : [];
  }
}
